import { processFilters } from '@/shared/lib/filters';

import { IProjectAndCastingsFiltersForm } from '@/shared/types/filters';

import { defaultFilterValues, defaultSalaryFilter } from './actorFilters';

/**
 * Дефолтные значения полей для сравнения при обработке фильтров кастингов
 */
const castingsFiltersDefaultValues = {
  salary: defaultSalaryFilter,
  total_salary: defaultSalaryFilter,
  project_category_id: defaultFilterValues.project_category_id,
  response_status: 'all' as const
};

/**
 * Ключи полей, которые сравниваются с дефолтами при обработке фильтров
 */
const CASTINGS_FILTERS_DEFAULT_KEYS = [
  'salary',
  'total_salary',
  'project_category_id',
  'response_status'
] as const;

/**
 * Обработка фильтров кастингов (установка/сброс query-параметров)
 * @param data - данные формы фильтров
 * @param setQueryParamsArg - функция для установки query-параметров
 */
export const processCastingsFilters = (
  data: IProjectAndCastingsFiltersForm,
  setQueryParamsArg: (params: Record<string, string | undefined>) => void
): void => {
  processFilters(
    data as unknown as Record<string, unknown>,
    setQueryParamsArg,
    castingsFiltersDefaultValues,
    [...CASTINGS_FILTERS_DEFAULT_KEYS]
  );
};

type ChangePage = (
  page: number,
  urlUpdateType?: 'replaceIn' | 'pushIn'
) => void;

/**
 * Создаёт обработчик применения фильтров кастингов
 * @param setQueryParams - функция установки query-параметров
 * @param changePage - функция смены страницы пагинации
 * @returns обработчик для onSubmit формы фильтров
 */
export const createApplyCastingsFilters = (
  setQueryParams: (params: Record<string, string | undefined>) => void,
  changePage: ChangePage
) => {
  return (data: IProjectAndCastingsFiltersForm): void => {
    processCastingsFilters(data, setQueryParams);
    changePage(1, 'replaceIn');
  };
};
